import axios from "axios"
import { headers } from "../../headers"
import { baseUrl } from "../BaseUrl"

export const envoyernotification = async(message)=>{
    return await axios.post(baseUrl('restauratrice/envoyernotification'), message);
}